"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultBlankTemplate = void 0;
var defaultBlankTemplate = {
  name: 'Blank Template',
  message: '',
  subject: '',
  is_default: false,
  type: 'personal'
};
exports.defaultBlankTemplate = defaultBlankTemplate;